import Hero from "@/components/sections/Hero";
import TrustMarquee from "@/components/sections/TrustMarquee";
import Engine from "@/components/sections/Engine";
import Divisions from "@/components/sections/Divisions";
import Industries from "@/components/sections/Industries";
import CaseStudies from "@/components/sections/CaseStudies";
import AiLab from "@/components/sections/AiLab";
import CTABand from "@/components/CTABand";

export default function Home() {
  return (
    <div data-testid="home-root">
      <Hero />
      <TrustMarquee />
      <Engine />
      <Divisions />
      <CaseStudies />
      <Industries />
      <AiLab />
      <CTABand
        headline={<>Ready to build your <span className="text-gradient-warm">growth system?</span></>}
        sub="Brand. Growth. Automation — engineered together. A 45-minute working call to map your blueprint."
        primary={{ label: "Book Strategy Call", to: "/contact" }}
        secondary={{ label: "Explore Services", to: "/services" }}
      />
    </div>
  );
}
